import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App'
import Attributes from './Attributes/Attributes'
import * as $ from "jquery";
import * as globals from './Globals/Globals';
import * as data from './datasets/datasets.json';
import "semantic-ui-css/semantic.min.css";
declare var module: any

ReactDOM.render(<App actvity="begin"/>, document.getElementById('app'));

if ((module as any).hot) {
    (module as any).hot.accept()
}